<template>
    <el-row>
        <el-upload :http-request="httpRequest" list-type="picture-card" :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove" :before-upload="beforeAvatarUpload" :file-list="fileListPic" action=""
            :on-exceed="onExceed" :limit="5" :disabled="uploadShow">
            <i class="el-icon-plus"></i>
        </el-upload>
        <!-- <el-dialog :visible.sync="dialogVisible" append-to-body width="50%">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog> -->
        <el-image-viewer v-if="dialogVisible" :url-list="getImageList"   :zIndex="3000" :initialIndex="initialIndex" :on-close="colseImg" class="img-viewer-row" />
    </el-row>
</template>
<script>
import { uploadFile } from '@/api/user'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
    components: {
        ElImageViewer,
    },
    props: {
        attachmentUrlList: {
            default: '',
            type: String
        },
        uploadShow: {
            default: false,
            type: Boolean
        }
    },
    computed: {
        getImageList() {
            let imageList = this.fileListPic.map((item) => {
                return item.url
            })
            return imageList
        }
    },
    data() {
        return {
            dialogImageUrl: '',
            initialIndex: 0,
            fileListPic: [],
            imgType: ["jpg", "JPG", "png", "PNG", "jpeg", "JPEG", "GIF", 'gif'],
            dialogVisible: false
        };
    },
    watch: {
        attachmentUrlList: {
            handler: function (val) {
                if (val) {
                    this.fileListPic = (val.length > 0 ? val.split(',') : []).map(url => {
                        return {
                            url: process.env.VUE_APP_BASE_API + '/minio/getImage?fileName=' + url,
                            code: url
                        }
                    })
                } else {
                    this.fileListPic = []
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        onExceed(files, fileList) {
            this.$message.error('最多支持上传5张图片!')
        },
        handleRemove(file, fileList) {
            console.log(file, fileList);
            this.fileListPic = fileList
            this.$emit('handleFileImg', this.fileListPic)
        },
        handlePictureCardPreview(file) {
            this.initialIndex = this.getImageList.indexOf(file.url) > -1 ? this.getImageList.indexOf(file.url) : 0;
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        async httpRequest(param) {
            let file = param.file
            let fd = new FormData()
            fd.append('file', file)
            const { code, result, message } = await uploadFile(fd)
            console.log(this.fileListPic, 'fileListPicfileListPic');
            if (code === 0) {
                this.fileListPic.push({
                    url: process.env.VUE_APP_BASE_API + '/minio/getImage?fileName=' + result,
                    code: result
                })
                this.$emit('handleFileImg', this.fileListPic)
            } else {
                this.$message.error(message)
            }
        },
        beforeAvatarUpload(file) {
            // 格式过滤
            let FileExt = file.name.substring(file.name.lastIndexOf('.') + 1)
            console.log(FileExt);
            const extension = this.imgType.includes(FileExt)
            const isLt2M = file.size / 1024 / 1024 < 5;
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 5MB!');
            }
            if (!extension) {
                this.$message.error('仅支持png, jpg, jpeg, gif格式')
            }
            return extension && isLt2M
        },
        colseImg () {
      this.dialogVisible = false
    },
    }
}
</script>